import { createSelector } from 'reselect';
import { PENDING_PARAMETERS_KEY } from './constants';
import searchSelector from '../searchSelector';

export const getPendingSearchParameters = createSelector(
    searchSelector,
    search => search[PENDING_PARAMETERS_KEY]
);
